import { render, staticRenderFns } from "./OrderConfirmationRokt.vue?vue&type=template&id=139c70f9&"
import script from "./OrderConfirmationRokt.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationRokt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports